import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { modalId: String };

  open(event) {
    event.preventDefault();
    const modal = document.getElementById(this.modalIdValue);
    if (!modal) return;

    modal.classList.remove('d-none');
    document.body.style.overflow = 'hidden';
  }

  close() {
    // When called from the card (opener), use modalIdValue
    // When called from the modal itself, use own element
    const modal = this.hasModalIdValue
      ? document.getElementById(this.modalIdValue)
      : this.element;
    if (!modal) return;

    modal.classList.add('d-none');
    document.body.style.overflow = '';
  }

  backdropClick(event) {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }
}
